import React, { useState } from 'react';

const PaperCardAgenda = ({
  title,
  authors = '',
  abstract,
  onSkip,
  onVote,
  onAdd,
  remainingVotes,
  hasVoted,
  showAddButton,
  showInstructions,
  isSwipingRight,
  isSwipingLeft,
  date,
  time_start,
  time_end,
  location,
}) => {
  const [isAbstractVisible, setIsAbstractVisible] = useState(false);

  const toggleAbstractVisibility = () => {
    setIsAbstractVisible(!isAbstractVisible);
  };

  const formattedDate = new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });

  const formattedTime = `${time_start} - ${time_end}`;

  return (
    <div className="card-agenda">
      {hasVoted && (
        <div className="voted-indicator">
          <i className="fas fa-check-circle"></i>
        </div>
      )}
      <h2 style={{ fontSize: '1em', padding: '0px 0' }}>{title}</h2>
      <p className="authors">{authors || 'No authors listed'}</p>
      <div className="event-details">
        <div className="event-time">
          <div>{formattedDate}</div>
          <div>{formattedTime}</div>
        </div>
        <div className="event-location">
          {location}
        </div>
      </div>
      <div className={`abstract-container ${isAbstractVisible ? 'visible' : ''}`}>
        <p className="abstract">{abstract || 'No abstract available'}</p>
      </div>
      <button onClick={toggleAbstractVisibility} className="toggle-abstract">
        {isAbstractVisible ? 'Hide Abstract' : 'Show Abstract'}
      </button>
      <div className="separator"></div>
      <div className="buttons">
        <div className="button-with-instruction">
          {showAddButton && (
            <button className="add" onClick={onAdd} style={{ marginLeft: '15px', marginBottom: '0px',marginTop: '-14px' }}>
            <i className="fas fa-plus"></i>
          </button>
          )}
          {showInstructions && showAddButton && <div className="instruction-text instruction-add">Add to agenda</div>}
        </div>
      </div>
    </div>
  );
};

export default PaperCardAgenda;
